import $ from "jquery";

function ajaxWrapperFile(type, url, data, returnFunc) {
	$.ajax({
		type: type,
		url: url,
		data: data,

		dataType: "json",
		processData: false,
		contentType: false,

		success: function (value) {
			returnFunc(value);
		},
		error: function (xhr, status, error) {
			console.log(xhr.responseText);
		},
	});
}

export default ajaxWrapperFile;
